var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgIconFutrSad = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M7.27 12h4.07v-2H7.27v-.93a5 5 0 019.57-2.2l1.8-.87A7 7 0 005.27 9.07V15h2v-3m7.09-1a1.5 1.5 0 003 0 1.5 1.5 0 00-3 0M7.7 21.93a5.05 5.05 0 016.75-2.38 4.71 4.71 0 01.58.32A5.08 5.08 0 0116.87 22l1.81-.83a7 7 0 00-12.33-1 7 7 0 00-.45.83l1.8.86"
})));

export default SvgIconFutrSad;